import QaseLogo from '../../assets/images/logo/logo.png';
import ApbLogo from '../../assets/images/logo/APB-Logo.svg';
import AcbaLogo from '../../assets/images/logo/ACBA-Logo.png';
import ScbaLogo from '../../assets/images/logo/SCCBA-logo.png';
import EpbcLogo from '../../assets/images/logo/EPBC-Logo.png';
import MsbaLogo from '../../assets/images/logo/MSBA-Logo.jpg';
import WbaLogo from '../../assets/images/logo/WBA-logo.png';
import CbaLogo from '../../assets/images/logo/CBA-Logo-2.png';
import NycLogo from '../../assets/images/logo/NYC-Logo.png';
import BasfLogo from '../../assets/images/logo/BASF-Logo.png';
import {
    MdOutlineEmail,
    MdOutlineLocationOn,
    MdOutlinePhone,
} from 'react-icons/md';

export const navbarTheme = {
    default: {
        containerType: true,
        logo: QaseLogo,
    },
    [process.env.REACT_APP_APB_SOURCE_ID]: {
        containerType: true,
        navbarBgColor: 'dark',
        logo: ApbLogo,
        navbarLink:
            'https://www.accessprobono.ca/our-programs/lawyer-referral-service',
    },
    [process.env.REACT_APP_ECBA_SOURCE_ID]: {
        containerType: true,
        navbarTextLogo: 'Erie County Bar Association',
        navbarTextLogoStyle: {
            color: '#303F49',
        },
        navbarLink:
            'https://www.eriebar.com/public/services/lawyer-referral-service',
    },
    [process.env.REACT_APP_ACBA_SOURCE_ID]: {
        containerType: true,
        logo: AcbaLogo,
    },
    [process.env.REACT_APP_SCBA_SOURCE_ID]: {
        containerType: true,
        logo: ScbaLogo,
        navbarLink: 'https://www.sccba.com/lawyer-referral-service/',
    },
    [process.env.REACT_APP_MNLRIS_SOURCE_ID]: {
        containerType: true,
        navbarTextLogo: 'Minnesota Lawyer Referral and Information Service',
        navbarTextLogoStyle: {
            color: '#0693e3',
        },
        navbarLink: 'https://www.mnlawyerreferral.org',
    },
    [process.env.REACT_APP_EPCB_SOURCE_ID]: {
        containerType: true,
        logo: EpbcLogo,
        navbarLink: 'https://www.elpasocountybar.org/site/public-resources',
    },
    [process.env.REACT_APP_CBA_SOURCE_ID]: {
        containerType: true,
        logo: CbaLogo,
        navbarLink:
            'https://www.chicagobar.org/chicagobar/CBA/CBA/Legal_Help_for_the_Public/Lawyer_Referral_Service.aspx',
    },
    [process.env.REACT_APP_WBA_SOURCE_ID]: {
        containerType: true,
        logo: WbaLogo,
        navbarLink: 'http://lrs.westbar.org',
    },
    [process.env.REACT_APP_MSBA_SOURCE_ID]: {
        containerType: true,
        logo: MsbaLogo,
        navbarLink: 'https://www.mainebar.org/page/LawyerReferralService',
    },
    [process.env.REACT_APP_NYC_SOURCE_ID]: {
        containerType: true,
        logo: NycLogo,
        showPoweredBy: false,
        showGoogleTranslate: true,
    },
    [process.env.REACT_APP_BASF_SOURCE_ID]: {
        containerType: true,
        logo: BasfLogo,
        showPoweredBy: false,
        showGoogleTranslate: true,
    },
};

export const footerTheme = {
    default: {
        footerType: 'qase',
        footerStyle: {
            backgroundColor: '#121529',
        },
    },
    elc: {
        footerType: 'elc',
        footerStyle: {
            backgroundColor: '#005454',
        },
        contacts: [
            {
                icon: <MdOutlineEmail size={24} color="#fff" />,
                text: 'intake@everyonelegal.ca',
                type: 'email',
                hrefText: 'mailto:intake@everyonelegal.ca',
            },
            {
                icon: <MdOutlinePhone size={24} color="#fff" />,
                text: '(778) 200-4478 (service)',
                type: 'phone',
                hrefText: 'tel:778-200-4478',
            },
            {
                icon: <MdOutlinePhone size={24} color="#fff" />,
                text: '(888) 600-2113 (toll-free)',
                type: 'phone',
                hrefText: 'tel:888-600-2113',
            },
        ],
    },
    [process.env.REACT_APP_APB_SOURCE_ID]: {
        footerType: process.env.REACT_APP_APB_SOURCE_ID,
        footerStyle: {
            backgroundColor: '#222222',
            backgroundImage: 'none',
        },
        contacts: [
            {
                text: 'Contact Us',
                type: 'externalLink',
                hrefText: 'https://www.accessprobono.ca/contact-us',
            },
            {
                icon: <MdOutlinePhone size={24} color="#fff" />,
                text: '1-604-878-7400',
                type: 'phone',
                hrefText: 'tel:+16048787400',
            },
        ],
    },
    [process.env.REACT_APP_ECBA_SOURCE_ID]: {
        footerType: process.env.REACT_APP_ECBA_SOURCE_ID,
        footerStyle: {
            backgroundColor: '#303F49',
            backgroundImage: 'none',
        },
        footerHeaderText: 'Erie County Bar Association',
        contacts: [
            {
                icon: <MdOutlinePhone size={24} color="#fff" />,
                text: '814-459-4411',
                type: 'phone',
                hrefText: 'tel:814-459-4411',
            },
            {
                icon: <MdOutlineLocationOn size={24} color="#fff" />,
                text: '429 West 6th Street Erie, Pennsylvania Erie 16507',
                type: 'address',
            },
        ],
    },
    [process.env.REACT_APP_ACBA_SOURCE_ID]: {
        footerType: process.env.REACT_APP_ACBA_SOURCE_ID,
        footerStyle: {
            backgroundColor: '#c41e3a',
            backgroundImage: 'none',
        },
        footerHeaderText: 'Alameda County Bar Association',
        footerDescription:
            'People seeking legal services or if you need a lawyer (510) 302-ACBA (2222) option 4',
    },
    [process.env.REACT_APP_SCBA_SOURCE_ID]: {
        footerType: process.env.REACT_APP_SCBA_SOURCE_ID,
        footerStyle: {
            backgroundColor: '#309C8A',
            backgroundImage: 'none',
        },
        footerHeaderText: 'Santa Clara County Lawyer Referral Service',
        contacts: [
            {
                icon: <MdOutlinePhone size={24} color="#fff" />,
                text: '669-302-7803',
                type: 'phone',
                hrefText: 'tel:669-302-7803',
            },
            {
                icon: <MdOutlineEmail size={24} color="#fff" />,
                text: 'LawyerReferral@sccba.com',
                type: 'email',
                hrefText: 'mailto:LawyerReferral@sccba.com',
            },
        ],
    },
    [process.env.REACT_APP_MNLRIS_SOURCE_ID]: {
        footerType: process.env.REACT_APP_SCBA_SOURCE_ID,
        footerStyle: {
            backgroundColor: '#0693e3',
            backgroundImage: 'none',
        },
        footerHeaderText: 'Minnesota Lawyer Referral and Information Service',
        contacts: [
            {
                icon: <MdOutlinePhone size={24} color="#fff" />,
                text: '612-752-6699',
                type: 'phone',
                hrefText: 'tel:612-752-6699',
            },
            {
                icon: <MdOutlineEmail size={24} color="#fff" />,
                text: 'mnlris@mnbars.org',
                type: 'email',
                hrefText: 'mailto:mnlris@mnbars.org',
            },
        ],
        oppenHours: [
            'Monday-Thursday: 9am - 4pm',
            'Friday: 9am - 3pm',
            'Saturday-Sunday: Closed',
        ],
    },
    [process.env.REACT_APP_MSBA_SOURCE_ID]: {
        footerType: process.env.REACT_APP_MSBA_SOURCE_ID,
        footerStyle: {
            backgroundColor: '#015488',
            backgroundImage: 'none',
        },
        footerHeaderText: '',
        footerDescription: '',
        contacts: [
            {
                text: 'Contact Us',
                type: 'address',
            },
            {
                icon: <MdOutlineEmail size={24} color="#fff" />,
                text: 'LRS@mainebar.org',
                type: 'email',
                hrefText: 'mailto:LRS@mainebar.org',
            },
        ],
    },
    [process.env.REACT_APP_WBA_SOURCE_ID]: {
        footerType: process.env.REACT_APP_WBA_SOURCE_ID,
        footerStyle: {
            backgroundColor: '#015488',
            backgroundImage: 'none',
        },
        footerHeaderText: '',
        footerDescription: '',
        contacts: [
            {
                text: 'Contact Us',
                type: 'address',
            },
            {
                text: 'Westmoreland Bar Association',
                type: 'address',
            },
            {
                text: 'Lawyer Referral Service',
                type: 'address',
            },
            {
                icon: <MdOutlinePhone size={24} color="#fff" />,
                text: '724-834-8490',
                type: 'phone',
                hrefText: 'tel:724-834-8490',
            },
            {
                icon: <MdOutlineEmail size={24} color="#fff" />,
                text: 'westbar.org@westbar.org',
                type: 'email',
                hrefText: 'mailto:westbar.org@westbar.org',
            },
            {
                text: 'Website',
                type: 'externalLink',
                hrefText: 'https://lrs.westbar.org/',
            },
        ],
    },
    [process.env.REACT_APP_CBA_SOURCE_ID]: {
        footerType: process.env.REACT_APP_CBA_SOURCE_ID,
        footerStyle: {
            backgroundColor: '#015488',
            backgroundImage: 'none',
        },
        footerHeaderText: '',
        footerDescription: '',
        contacts: [
            {
                icon: <MdOutlinePhone size={24} color="#fff" />,
                text: '(312) 554-2001',
                type: 'phone',
                hrefText: 'tel:(312) 554-2001',
            },
        ],
        oppenHours: ['9:00 am - 4:45 pm, Monday to Friday'],
    },
    [process.env.REACT_APP_NYC_SOURCE_ID]: {
        footerType: process.env.REACT_APP_NYC_SOURCE_ID,
        footerPoweredBy: false,
        footerStyle: {
            backgroundColor: '#f6f6f6',
            backgroundImage: 'none',
        },
        colorMode: 'light',
        footerHeaderText: '',
        footerDescription: '',
        contacts: [
            {
                text: 'Contact Us',
                type: 'address',
            },
            {
                icon: <MdOutlinePhone size={24} color="#333" />,
                helperText: 'English',
                text: '917-983-2327',
                type: 'phone',
                hrefText: 'tel:9179832327',
            },
            {
                icon: <MdOutlinePhone size={24} color="#333" />,
                helperText: 'Español',
                text: '917-832-1927',
                type: 'phone',
                hrefText: 'tel:9178321927',
            },
            {
                icon: <MdOutlineEmail size={24} color="#333" />,
                text: 'lrs@nycbar.org',
                type: 'email',
                hrefText: 'mailto:lrs@nycbar.org',
            },
            {
                text: 'New York City Bar Legal Referral Service',
                type: 'externalLink',
                hrefText:
                    'http://maps.google.com/maps?q=New%20York%20City%20Bar%20Legal%20Referral%20Service%20%2042%20West%2044th%20Street%20New%20York%20NY%2010036',
            },
            {
                text: '42 West 44th Street, New York, NY 10036',
                type: 'externalLink',
                hrefText:
                    'http://maps.google.com/maps?q=New%20York%20City%20Bar%20Legal%20Referral%20Service%20%2042%20West%2044th%20Street%20New%20York%20NY%2010036',
            },
        ],
        oppenHours: [
            'Monday - Friday 8:30 AM to 5:30 PM',
            'Closed from 1:00 PM to 2:00 PM daily',
            'Closed on all national holidays',
        ],
    },
    [process.env.REACT_APP_BASF_SOURCE_ID]: {
        footerType: process.env.REACT_APP_BASF_SOURCE_ID,
        footerStyle: {
            backgroundColor: '#a4a3a3',
            backgroundImage: 'none',
        },
        footerHeaderText: 'Lawyer Referral & Information Service (LRIS)',
        footerDescription: 'If you need a lawyer, contact us:',
        contacts: [
            {
                icon: <MdOutlinePhone size={24} color="#fff" />,
                text: '(415) 989-1616',
                type: 'phone',
                hrefText: 'tel:415-989-1616',
            },
            {
                text: 'TTD/TTY: 711',
                type: 'address',
            },
        ],
    },
};
